<div *ngIf="localService.languageContent.payments" class="{{localService.selectedLanguageCode}}">
    <ng-template #content let-offcanvas>
        <app-canvas-header [title]="localService.languageContent.payments.payment"
            (onClose)="onCloseTrigger()"></app-canvas-header>
        <iframe *ngIf="isChildWindow != null && isChildWindow == false" #frame width="100%" height="100%" id="frame"
            name="frame" frameborder="0">
        </iframe>
        <div *ngIf="isChildWindow" style="margin: 10px;text-align: justify;" class="{{localService.selectedLanguageCode}}">
            {{localService.languageContent.payments.redirected}}
        </div>
    </ng-template>
</div>
<form *ngIf="encRequest && action" #form ngNoForm target="frame" id="nonseamless"
    method="post" name="redirect" [action]="action">
    <input type="hidden" id="encRequest" name="encRequest" [ngModel]="encRequest">
    <input type="hidden" name="access_code" id="access_code" [ngModel]="accessCode">
</form>